import React, { useEffect } from 'react';
import { Burger, Divider, Drawer } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useLocation } from 'react-router-dom';
import { useAuth } from '@/providers/AuthProvider';
import { useContent } from '@/providers/ContentProvider';
import { NavLink } from '../../navlink/NavLink';
import { AppPaths } from '@/configs/appPaths';
import styles from '../Navbar.module.scss';

interface Props {
	baseSlug: string;
}

export const HamburgerMenu: React.FC<Props> = ({ baseSlug }) => {
	const { getContent } = useContent();

	const [opened, { toggle, close }] = useDisclosure(false);

	const { pathname } = useLocation();
	useEffect(() => {
		close();
	}, [pathname]);

	const { logout } = useAuth();

	return (
		<div className={styles.mobileMenuContainer}>
			<Burger
				size="md"
				opened={opened}
				onClick={toggle}
				aria-label={opened ? 'Close navigation' : 'Open navigation'}
			/>
			<Drawer
				opened={opened}
				onClose={close}
				classNames={{ header: 'd-none' }}
				size="100%"
			>
				<nav className={styles.mobileMenu}>
					<NavLink className={styles.item} to={AppPaths.INVESTMENTS} end>
						{getContent(`${baseSlug}investments`)}
					</NavLink>
					<NavLink className={styles.item} to={AppPaths.PROJECT_TEMPLATES} end>
						{getContent(`${baseSlug}productTemplates`)}
					</NavLink>
					<NavLink className={styles.item} to={AppPaths.COMPANY} end>
						{getContent(`${baseSlug}company`)}
					</NavLink>
					{<Divider w="100%" my="sm" />}
					<NavLink className={styles.item} to={AppPaths.ACCOUNT} end>
						{getContent(`${baseSlug}account`)}
					</NavLink>
					<NavLink to="" onClick={logout}>
						{getContent(`${baseSlug}logout`)}
					</NavLink>
				</nav>
			</Drawer>
		</div>
	);
};
